<template>
    <rkm-overlay>
        <rkm-layout-body title="Reimpressão lançamento de resultado">
            <rkm-layout-content v-if="loaded">
                <List :data="{ initials, form, model, additionals }" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-imagem/reimpressao-resultado/List'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            reimpressao: this.getConectaSusRepository('exameImagem.reimpressaoResultado')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.reimpressao.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, object, data]
}
</script>